import React from 'react';

import { useGraphQLQuery } from '@betterment/js-runtime';
import { CardLoader, ErrorBoundary } from '@betterment/shared-components';

import { TaxSavingsDocument } from './graphql/taxSavings.generated';
import { TaxSavingsDisabledCard } from './TaxSavingsDisabledCard';
import { TaxSavingsEnabledCard } from './TaxSavingsEnabledCard';

import { DateRangeOption } from '../../../../graphql/schema';

interface TaxSavingsCardViewProps {
  dateRangeOption?: DateRangeOption;
}

const TaxSavingsCardView: React.FC<TaxSavingsCardViewProps> = ({ dateRangeOption = DateRangeOption.AllTime }) => {
  const { data } = useGraphQLQuery(TaxSavingsDocument, {
    variables: { dateRangeOption },
    throwOnError: true,
  });

  if (!data) return <CardLoader />;

  const allTimeTaxSavings = data.performance.totals.investing?.allTimeTlhEstimatedTaxSavings;
  const taxLossesHarvested = data.performance.totals.investing?.taxLossesHarvested;

  if (!taxLossesHarvested) {
    return <TaxSavingsDisabledCard />;
  }

  if (taxLossesHarvested.cents === 0) {
    return <TaxSavingsEnabledCard />;
  }

  if (allTimeTaxSavings) {
    return <TaxSavingsEnabledCard allTimeTaxSavings={allTimeTaxSavings} taxLossesHarvested={taxLossesHarvested} />;
  }

  return null;
};

export const TaxSavingsCard: React.FC<TaxSavingsCardViewProps> = props => (
  <ErrorBoundary fallbackType="none">
    <TaxSavingsCardView {...props} />
  </ErrorBoundary>
);
